<template>
  <div 
    class="document-card" 
    role="article"
    :aria-label="`Document: ${document.name}`"
    tabindex="0"
    @click="$emit('preview', document)"
    @keydown.enter="$emit('preview', document)"
    @keydown.space.prevent="$emit('preview', document)"
  >
    <!-- File Type Icon or Image Thumbnail -->
    <div class="document-card__icon" aria-hidden="true">
      <img 
        v-if="document.is_image && document.view_url" 
        :src="document.view_url" 
        :alt="`Thumbnail of ${document.name}`"
        class="document-card__thumbnail"
        loading="lazy"
      />
      <div v-else class="document-card__file-icon" v-html="document.icon"></div>
    </div>
    
    <!-- Document Info -->
    <div class="document-card__info">
      <h3 class="document-card__name" :title="document.name">{{ document.name }}</h3>
      
      <themed-badge 
        v-if="document.category_name" 
        variant="secondary"
        class="document-card__category-badge"
        role="status"
        :aria-label="`Category: ${document.category_name}`"
      >
        {{ document.category_name }}
      </themed-badge>
      
      <p class="document-card__meta">
        <span class="document-card__size" :aria-label="`File size: ${document.readable_size}`">{{ document.readable_size }}</span>
        <span class="document-card__separator" aria-hidden="true">•</span>
        <span class="document-card__uploader" :aria-label="`Uploaded by: ${document.uploaded_by_name}`">{{ document.uploaded_by_name }}</span>
      </p>
      
      <p class="document-card__date">
        <time :datetime="document.created_at" :aria-label="`Uploaded on: ${document.uploaded_at}`">
          {{ document.uploaded_at }}
        </time>
      </p>
    </div>
    
    <!-- Actions -->
    <div class="document-card__actions" @click.stop role="group" aria-label="Document actions">
      <themed-button 
        @click="$emit('preview', document)" 
        variant="ghost" 
        size="icon"
        class="document-card__action-button"
        :aria-label="`Preview ${document.name}`"
      >
        <theme-icon icon="eye" type="icons" classes="w-4 h-4" aria-hidden="true" />
      </themed-button>
      
      <themed-button 
        @click="$emit('download', document)" 
        variant="ghost" 
        size="icon"
        class="document-card__action-button"
        :aria-label="`Download ${document.name}`"
      >
        <theme-icon icon="download" type="icons" classes="w-4 h-4" aria-hidden="true" />
      </themed-button>
      
      <themed-button 
        v-if="canEdit" 
        @click="$emit('edit', document)" 
        variant="ghost" 
        size="icon"
        class="document-card__action-button"
        :aria-label="`Edit ${document.name}`"
      >
        <theme-icon icon="edit" type="icons" classes="w-4 h-4" aria-hidden="true" />
      </themed-button>
      
      <themed-button 
        v-if="canDelete" 
        @click="$emit('delete', document)" 
        variant="ghost" 
        size="icon"
        class="document-card__action-button document-card__action-button--delete"
        :aria-label="`Delete ${document.name}`"
      >
        <theme-icon icon="trash" type="icons" classes="w-4 h-4" aria-hidden="true" />
      </themed-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentCard',
  
  props: {
    document: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  }
};
</script>
